const initialState = {
    guilds: [],
    activeGuild: null,
    threads: [],
    pagination: {
        pagination_has_next_page: null,
        pagination_current_page: null,
        pagination_total: null,
    }
}

export default function guilds(state = initialState, action) {
    switch(action.type) {

        case 'SET_GUILDS':
            return {
                ...state,
                guilds: action.payload
            }
        
        case 'UPDATE_GUILD':
            return {
                ...state,
                guilds: state.guilds.map(r => {
                    if(r._id === action.payload._id) {
                        return action.payload
                    }
                    return r
                })
            }

        case 'REPLACE_ALL_GUILD_THREADS':
            return {
                ...state,
                threads: action.payload.threads,
                pagination: {
                    pagination_has_next_page: action.payload.pagination_has_next_page,
                    pagination_current_page: action.payload.pagination_current_page,
                    pagination_total: action.payload.pagination_total,
                }
            }  

        case 'SET_ACTIVE_GUILD':
            return {
                ...state,
                activeGuild: action.payload
            }

        case 'APPEND_GUILD_THREADS':
            return {
                ...state,
                threads: [...state.threads, ...action.payload.threads],
                pagination: {
                    pagination_has_next_page: action.payload.pagination_has_next_page,
                    pagination_current_page: action.payload.pagination_current_page,
                    pagination_total: action.payload.pagination_total,
                }
            }  

        default:
            return state    
    }
}